/**
 * Cache Invalidation Service - Force refresh React Query caches
 * Sử dụng đúng query keys từ các hooks hiện tại
 */
import { useQueryClient } from '@tanstack/react-query';

export const useCacheInvalidation = () => {
  const queryClient = useQueryClient();
  
  return {
    // Invalidate reports với đúng query keys
    invalidateReports: () => {
      queryClient.invalidateQueries({ queryKey: ['supabase-reports'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-report'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-report-legacy'] });
      queryClient.invalidateQueries({ queryKey: ['reports-stats'] });
    },
    
    // Invalidate periods
    invalidatePeriods: () => {
      queryClient.invalidateQueries({ queryKey: ['report-periods'] });
      queryClient.invalidateQueries({ queryKey: ['period-navigation'] });
    },
    
    // Invalidate teams
    invalidateTeams: () => {
      queryClient.invalidateQueries({ queryKey: ['report-teams'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-teams'] });
    },
    
    // Invalidate users  
    invalidateUsers: () => {
      queryClient.invalidateQueries({ queryKey: ['supabase-users'] });
    },
    
    // Invalidate all report-related data - AGGRESSIVE APPROACH
    invalidateAllReportsData: () => {
      console.log('🗑️ Starting aggressive cache invalidation...');
      
      // Remove all queries instead of just invalidating
      queryClient.removeQueries({ queryKey: ['supabase-reports'] });
      queryClient.removeQueries({ queryKey: ['supabase-report'] });
      queryClient.removeQueries({ queryKey: ['supabase-report-legacy'] });
      queryClient.removeQueries({ queryKey: ['reports-stats'] });
      
      // Also invalidate (backup)
      queryClient.invalidateQueries({ queryKey: ['supabase-reports'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-report'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-report-legacy'] });
      queryClient.invalidateQueries({ queryKey: ['reports-stats'] });
      
      // Periods
      queryClient.removeQueries({ queryKey: ['report-periods'] });
      queryClient.invalidateQueries({ queryKey: ['report-periods'] });
      queryClient.invalidateQueries({ queryKey: ['period-navigation'] });
      
      // Teams & Users (in case references changed)
      queryClient.invalidateQueries({ queryKey: ['report-teams'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-teams'] });
      queryClient.invalidateQueries({ queryKey: ['supabase-users'] });
      
      console.log('✅ Aggressive cache invalidation completed');
    },
    
    // Force clear all cache (nuclear option)
    clearAll: () => {
      queryClient.clear();
    },
    
    // Remove specific cache entries completely
    removeReportCache: () => {
      queryClient.removeQueries({ queryKey: ['supabase-reports'] });
      queryClient.removeQueries({ queryKey: ['supabase-report'] });
      queryClient.removeQueries({ queryKey: ['supabase-report-legacy'] });
    },
    
    // Nuclear option - force page reload
    forcePageReload: () => {
      console.log('💥 Nuclear option: Force page reload');
      window.location.reload();
    }
  };
};

/**
 * Utility function để delay execution
 */
export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));